var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade", "leave-active-class": "animated bounceOut" } },
    [
      _c(
        "div",
        { staticClass: "integral-mask", staticStyle: { "z-index": "9999" } },
        [
          _c(
            "div",
            { ref: "bounce", staticClass: "animated zoomIn animate__faster" },
            [
              _c("div", { key: "animatedanimate", staticClass: "lottie" }, [
                _c("div", { staticClass: "line" }, [
                  _c("img", {
                    attrs: {
                      src: "https://img.webloom.cn/img/scorePng1.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _c("p", { staticClass: "t" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.action) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "b" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.scoreNum) +
                          "+" +
                          _vm._s(_vm.score) +
                          "\n              "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "coin" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/img/plaza/score/金币弹框.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "score" }, [
                    _vm._v(_vm._s(_vm.score))
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-94f20550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-94f20550","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/IntegralMask/src/main.vue
// module id = null
// module chunks = 